import * as ApiUrls from "./ApiUrl.Import";
import { AxiosResponse } from "axios";
import { axiosInstance } from "../AxiosInterceptor";
import { FileExportRequest, FileUploadRequestParameters, FileUploadRequestResponse, UploadRequestParameters } from "../../Model/Dto/Upload";

interface IData {
  ImportType: string;
  ScorecardId: string;
  ImportAction: number;
  file: any;
  options?: any;
  setPercentageUpload: any;
}

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


export const ImportBusService = {

  UploadFile: async (data: IData): Promise<AxiosResponse<any>> => {

    const options = {
      onUploadProgress: (progressEvent: any) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total)
        data.setPercentageUpload(percent);
      },
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }
    let fileModel;
    await getBase64(data.file).then(result => {
      fileModel = {
        ScorecardId: data.ScorecardId,
        ImportAction: data.ImportAction,
        ImportType: data.ImportType,
        FileData: {
          Name: data.file.name,
          Size: data.file.size,
          Type: data.file.type,
          Content: result
        }
      }
    });
    return axiosInstance.post(ApiUrls.Import, fileModel, options);
  }
}

